// mutations
const INVENTORY_PRODUCTS_CATEGORIES_ALL = (state, inventoryProductsCategories) => {
  if (inventoryProductsCategories.code === 1) {
    state.inventoryProductsCategories = inventoryProductsCategories.data
    state.status = 'success'
  } else {
    alert(inventoryProductsCategories.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_CATEGORIES_FORM = (state, inventoryProductsCategories) => {
  if (inventoryProductsCategories.code === 1) {
    state.inventoryProductsCategories = inventoryProductsCategories.data
    state.status = 'success'
  } else {
    alert(inventoryProductsCategories.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_CATEGORIES_SHOW = (state, inventoryProductsCategories) => {
  if (inventoryProductsCategories.code === 1) {
    state.inventoryProductsCategories = inventoryProductsCategories.data
    state.status = 'success'
  } else {
    alert(inventoryProductsCategories.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_CATEGORIES_CREATE = (state, inventoryProductsCategories) => {
  if (inventoryProductsCategories.code === 1) {
    state.inventoryProductsCategories = inventoryProductsCategories.data
    state.status = 'success'
    alert(inventoryProductsCategories.message)
  } else {
    alert(inventoryProductsCategories.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_CATEGORIES_UPDATE = (state, inventoryProductsCategories) => {
  if (inventoryProductsCategories.code === 1) {
    state.inventoryProductsCategories = inventoryProductsCategories.data
    state.status = 'success'
    alert(inventoryProductsCategories.message)
  } else {
    alert(inventoryProductsCategories.message)
    state.status = 'error'
  }
}

const INVENTORY_PRODUCTS_CATEGORIES_DELETE = (state, inventoryProductsCategories) => {
  if (inventoryProductsCategories.code === 1) {
    state.inventoryProductsCategories = inventoryProductsCategories.data
    state.status = 'success'
    alert(inventoryProductsCategories.message)
  } else {
    alert(inventoryProductsCategories.message)
    state.status = 'error'
  }
}

export default {
  INVENTORY_PRODUCTS_CATEGORIES_ALL,
  INVENTORY_PRODUCTS_CATEGORIES_FORM,
  INVENTORY_PRODUCTS_CATEGORIES_SHOW,
  INVENTORY_PRODUCTS_CATEGORIES_CREATE,
  INVENTORY_PRODUCTS_CATEGORIES_UPDATE,
  INVENTORY_PRODUCTS_CATEGORIES_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/inventory/products/categories/mutations.js